import React from "react";
import { useParams, useNavigate, Navigate } from "react-router-dom";
import { ChevronLeft, TriangleAlert } from "lucide-react";
import { LEGAL } from "@/lib/legalContent";
import { Logo } from "@/components/Logo";

export default function Legal() {
  const { doc } = useParams();
  const navigate = useNavigate();
  const content = LEGAL[doc];
  if (!content) return <Navigate to="/" replace />;

  return (
    <div className="min-h-screen bg-[#FCFBF8] text-[#2D2B2A]">
      <header className="sticky top-0 z-10 backdrop-blur-xl bg-[#FCFBF8]/85 border-b border-[#E8E3DA]">
        <div className="max-w-2xl mx-auto px-5 h-16 flex items-center justify-between">
          <button data-testid="legal-back-btn" onClick={() => navigate(-1)} className="h-9 w-9 rounded-full bg-[#F2EFE9] flex items-center justify-center">
            <ChevronLeft size={20} />
          </button>
          <span className="font-display font-extrabold">{content.title}</span>
          <Logo size={28} withWordmark={false} to="/" />
        </div>
      </header>

      <div className="max-w-2xl mx-auto px-5 py-8" data-testid={`legal-${doc}-screen`}>
        <h1 className="font-display text-3xl font-black">{content.title}</h1>
        {content.meta && <p className="text-sm text-[#9A938B] mt-1">{content.meta}</p>}

        {content.warn && (
          <div className="rounded-3xl bg-[#D9534F] text-white p-5 mt-5 flex flex-col items-center text-center gap-2">
            <TriangleAlert size={28} />
            <p className="font-extrabold text-lg">Not a substitute for a veterinarian</p>
            <p className="text-white/90 text-sm">{content.warn}</p>
          </div>
        )}

        <div className="mt-6 space-y-5">
          {content.sections.map((s) => (
            <div key={s.title}>
              <h2 className="font-display font-extrabold text-lg">{s.title}</h2>
              <p className="text-[#4A4746] leading-relaxed mt-1">{s.body}</p>
            </div>
          ))}
        </div>

        {content.foot && (
          <p className="text-xs italic text-[#9A938B] bg-[#F2EFE9] rounded-2xl p-4 mt-8">{content.foot}</p>
        )}
      </div>
    </div>
  );
}
